// extracted by mini-css-extract-plugin
export default {"link":"ButtonDark_link__JLktQ"};